import { render } from "./icp-footer.vue?vue&type=template&id=3e41032a&scoped=true"
const script = {}

import "./icp-footer.vue?vue&type=style&index=0&id=3e41032a&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e41032a"]])

export default __exports__